import * as localforage from "localforage";
const _defaultInstanceName = "__default_lf_store__";

export default class LocalForageManager {

  private _dbName?: string;
  private _instance?: LocalForage;

  constructor(_dbName?: string) {
    this._dbName = _dbName || _defaultInstanceName;
    this._instance = this.getLocalforageInstance();
  }


  /**
   * 获取indexdb实例
   * @returns 
   */
  public getLocalforageInstance(): LocalForage {
    return localforage.createInstance({ name: this._dbName });
  }

  /**
   * 读取
   * @param key
   * @returns
   */
  public async get(key: string): Promise<any> {
    if (this._instance)
      return await (this._instance).getItem(key);
    else return
  }

  /**
   * 写入
   * @param key
   * @param value
   * @returns
   */
  public async set(key: string, value: any) {
    try {
      if (this._instance)
        await this._instance.setItem(key, value);
      else throw Error()
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  }
}